import { match } from "ts-pattern";
import { z } from "zod";
import {
  ControlDataTypeKey
} from "./prop-controllers";
const typeArg = () => ({});
const versionedPropDef = (type, valueSchema, discriminator, _rawOptionsType, _ctor) => {
  const schemaV0 = valueSchema;
  const schemaV1 = z.object({
    [ControlDataTypeKey]: z.literal(discriminator.dataKey),
    value: valueSchema
  });
  const schema = z.union([schemaV0, schemaV1]);
  const r = (options) => {
    return {
      type,
      version: discriminator.version,
      options: options ?? {}
    };
  };
  r.schema = schema;
  r.type = type;
  r.discriminator = discriminator;
  r.fromPropData = (propData) => match(propData).with(
    {
      [ControlDataTypeKey]: discriminator.dataKey
    },
    (v1) => v1.value
  ).otherwise((v0) => v0);
  r.toPropData = (data, descriptor) => match(descriptor).with(
    { version: discriminator.version },
    () => ({
      [ControlDataTypeKey]: discriminator.dataKey,
      value: data
    })
  ).otherwise(() => data);
  return r;
};
export {
  typeArg,
  versionedPropDef
};
//# sourceMappingURL=versioned.js.map